// extracted by mini-css-extract-plugin
module.exports = {"form":"description_form_form__2_5tP","input":"description_form_input__2HxZ4"};